import * as React from 'react';
import {Text} from '../Text';
import {Item} from './components';
import styles from './accordion.scss';

export interface AccordionProps {
  title?: string;
  children: React.ReactNode;
}
export class Accordion extends React.PureComponent<AccordionProps> {
  static Item = Item;

  render() {
    const {title, children} = this.props;

    return (
      <div>
        {title && <Text component="h5" type="h5" text={title} />}
        <div className={styles.accordion}>{children}</div>
      </div>
    );
  }
}

export default Accordion;
